<div *ngIf="products" class="row">
    <!-- <div *ngFor="let product of products; index as i" class="col-md-4 col-lg-4 col-sm-6 col-12 my-2">
        <app-product-card-stack [product]="product"></app-product-card-stack>
    </div> -->
    <div *ngFor="let product of products; index as i" class="col-md-4 col-lg-4 col-sm-6 col-12 my-2">
        <app-product-card [product]="product"></app-product-card>
    </div>
    <div [innerHTML]="schemaMarkup"></div>
</div>